/** Canonical gameplay bounds without loading terrain or world objects. */
export const WORLD_HALF_EXTENT_METERS = 4_096;
export const WORLD_SIZE_METERS = WORLD_HALF_EXTENT_METERS * 2;
export const WORLD_MIN_COORDINATE = -WORLD_HALF_EXTENT_METERS;
export const WORLD_MAX_COORDINATE = WORLD_HALF_EXTENT_METERS;
export const TERRAIN_CHUNK_SIZE = 32;
